import { useState } from 'react';

type UseResidentSettingDetailsMuteScenariosAccordionReturn = {
  expanded: boolean;
  toggleExpanded: () => void;
};

const useResidentSettingDetailsMuteScenariosAccordion = (): UseResidentSettingDetailsMuteScenariosAccordionReturn => {
  const [expanded, setExpanded] = useState(false);

  return {
    expanded,
    toggleExpanded: () => setExpanded(!expanded),
  };
};

export default useResidentSettingDetailsMuteScenariosAccordion;
